import React from 'react'
import useGoogleTagManager from './hooks/useGoogleTagManager'
import initialState from './services/config'
import { UserProvider } from './services/StateContext'
import Routes from './Routes'
import { HistoryProvider } from './Components/useHistory'
// Set global locale:
import { setDefaultOptions } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { PatientProvider } from 'Components/usePatientContext'
// import RouterHistory, { customHistory } from 'Components/RouterHistory'
// import { BrowserRouter } from 'react-router-dom'
// import { useLocation } from 'react-router-dom'
setDefaultOptions({ locale: ptBR })
    

const App = () => {
    useGoogleTagManager();
    
    return (
        <PatientProvider>
            <UserProvider initialState={initialState} > 
                <HistoryProvider>
                    <Routes />
                </HistoryProvider>
            </UserProvider>
        </PatientProvider>
    )
}
    


export default App
